import { Action, AnyAction } from "redux";

export enum ActionType {
  OPEN_DRAWER = "OPEN_DRAWER",
  CLOSE_DRAWER = "CLOSE_DRAWER",
  OPEN_ALERT = "OPEN_ALERT",
  CLOSE_ALERT = "CLOSE_ALERT",
  OPEN_SPINNER = "OPEN_SPINNER",
  CLOSE_SPINNER = "CLOSE_SPINNER",
  LOGIN_REQUEST = "LOGIN_REQUEST",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_FAIL = "LOGIN_FAIL",
  LOGOUT_REQUEST = "LOGOUT_REQUEST",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  LOGOUT_FAIL = "LOGOUT_FAIL",
  SET_LOCALES = "SET_LOCALES",
  ADD_FLIGHT_DATA = "ADD_FLIGHT_DATA",
  OPEN_SNACKBAR = "OPEN_SNACKBAR",
  CLOSE_SNACKBAR = "CLOSE_SNACKBAR",
  OPEN_LAUNCHPAD = "OPEN_LAUNCHPAD",
  OPEN_MODAL = "OPEN_MODAL",
  CLOSE_MODAL = "CLOSE_MODAL",
  SET_THEME = "SET_THEME",
  TOGGLE_UIDS = "TOGGLE_UIDS",
  UPDATE_BULK_BATCH = "UPDATE_BULK_BATCH",
  CREATE_BULK_BATCH = "CREATE_BULK_BATCH",
  UPDATE_USER_APP_SETTINGS = "UPDATE_USER_APP_SETTINGS",
  GENDEC_SET_STALE = "GENDEC_SET_STALE",
  GENDEC_SET_CONFIG = "GENDEC_SET_CONFIG",
}

export type appSettings =
  | "mosaicLayout"
  | "timelineAircraftFilters"
  | "crewScheduleFilters"
  | "flightTimelineRowHeightPercentage"
  | "flightTimelineViewScale"
  | "flightDisplayMenuCentered"
  | "blockInfo"
  | "followCurrentDate"
  | "highlightFlightSettings"
  | "savedSearchFilters"
  | "crewScheduleHideTooltips"
  | "statusBarBehavior";

export interface IAppAction extends Action<ActionType | AnyAction> {
  payload?: any;
  updateOnly?: appSettings;
}
